import '.cc{position:relative;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.h5{border-radius:20px;}.ssr-plugin'
import '.bh{border:var(--blue-border);}.ssr-plugin'
import '.bx{padding:1.5rem;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.it{transition:box-shadow 0.2s ease;}.ssr-plugin'
import '.fg{width:2rem;}.ssr-plugin'
import '.fh{height:2rem;}.ssr-plugin'
import '.eq{border-radius:50%;}.ssr-plugin'
import '.iu{border:1px solid var(--shades-blue-800);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.bo{flex-shrink:0;}.ssr-plugin'
import '.iv{margin-left:1rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'

export interface SubsidyCardProps {
  title: string
  description: string
  style?: Style
  onClick?: () => void
}

export const SubsidyCard = ({
  title,
  description,
  style,
  onClick,
}: SubsidyCardProps) => {
  return (
    <styled.div className="cc ae h5 bh bx a1 it"
      data-testid="subsidy-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.08)',
            }
          : {},
        ...style,
      }}
    >
      <Column gap="0.625rem" alignItems="stretch">
        {/* Header Section */}
        <Row
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Title */}
          <Title.H5 style={{ color: 'var(--shades-blue-800)' }}>
            {title}
          </Title.H5>

          {/* Circular Icon */}
          <div className="fg fh eq iu a b f bo iv"
          >
            <FontAwesomeIcon
              icon={faArrowUpRight}
              style={{
                color: 'var(--shades-blue-800)',
                height: '1.25rem',
              }}
            />
          </div>
        </Row>

        {/* Body Section */}
        <Text.Medium
          style={{
            color: 'var(--shades-blue-600)',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </styled.div>
  )
}
